import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const PrivacyPage = () => {
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Privacy Policy | Colours Boutique</title>
                <meta name="description" content="Read the Colours Boutique privacy policy to understand how customer information is collected, used, and protected." />
                <link rel="canonical" href="https://coloursboutique.com/privacy" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Privacy & Cookies Policy')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Privacy Policy')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="privacy-content" style={{ lineHeight: '1.8' }}>
                                        <p className="mb-4" data-aos="fade-up" data-aos-delay="200">
                                            {translateSync("At Colours Boutique, we are committed to safeguarding your privacy. We collect, use, and protect your personal data in accordance with applicable data protection laws.")}
                                        </p>
                                        <p className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            {translateSync(' By using our website and services, you agree to the collection and use of your information in accordance with this policy.')}
                                        </p>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('What Information We Collect')}</h3>
                                            <p className="mb-2">{translateSync('We may collect the following types of data:')}</p>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Personal identification information (Name, email address, phone number, etc.)')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Order and shipping details')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Payment and transaction history')}</span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Browser cookies and usage data')}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('How We Use Your Information')}</h3>
                                            <p className="mb-2">{translateSync('Your information helps us to:')}</p>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Process and manage your orders securely')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Provide customer support and respond to inquiries')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Improve our store content and services')}</span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Send important updates, promotional materials, and feedback requests (only with your consent)')}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Cookies Policy')}</h3>
                                            <p className="mb-0">
                                                {translateSync("Our website uses cookies to enhance user experience. Cookies are small data files stored on your device to remember preferences and track usage. You can choose to disable cookies through your browser settings, although this may affect the functionality of the site.")}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('Data Security')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We implement industry-standard security measures to protect your data against unauthorized access, alteration, or disclosure.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="700">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>5. {translateSync('Third-Party Disclosure')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We do not sell or share your personal data with third parties, except as required to provide our services (e.g., shipping partners, payment processors) or comply with legal obligations.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="800">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>6. {translateSync('Your Rights')}</h3>
                                            <p className="mb-2">{translateSync('You have the right to:')}</p>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Access your data')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Request corrections')}</span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Withdraw consent or request data deletion')}</span>
                                                </li>
                                            </ul>
                                            <p className="mb-0 mt-3">
                                                {translateSync('To exercise these rights, contact us at')} <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PrivacyPage;